import { Box, Grid } from "@mui/material";
import LiveDarshan from "../../components/card/LiveDarshan/LiveDarshan";

import "./LiveDarshanView.scss";
import LiveDarshanContent from "../../components/BlogContent/LiveDarshanContent";

function LiveDarshanView(props: any) {

const sortedList = [...props.darshanList].sort((a, b) => {
  const postionA = Number(a?.position) || 0;
  const postionB = Number(b?.position) || 0;
  return postionB - postionA;
});


  return (
    <Box className="pageContainer liveDarshanPage">
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={2} lg={3} xl={3} className="pagehdLeftBlock"></Grid>

          <Grid item xs={12} md={8} lg={6} xl={6} className="pageCenterBlock" >
            <Grid container spacing={2} className="liveDarshanView" data-scroll-id={"live-Darshan-list"}>
              {sortedList?.map((item: any, id: any) => (
                <Grid item xs={12} sm={6} key={id}>
                  <LiveDarshan
                    templeData={item}
                    image={item.media?.url}
                    name={item.templeName}
                    location={item.state}
                    goToTempleDarshan={props.goToTempleDarshan}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid item xs={12} md={2} lg={3} xl={3} className="pagehdRightBlock"></Grid>
        </Grid>
      </Box>
      <Box className="bottomBlogContent">
        <LiveDarshanContent/>
      </Box>
    </Box>
  );
}


export default LiveDarshanView;
